import { Component } from '@angular/core';
import { NewModalRef } from 'outshared-lib';
import { CoverageInput } from '../../insurance-coverage/insurance-coverage-control';

@Component({
    selector: 'ins-coverage-modal',
    templateUrl: './coverage-modal.html',
    styleUrls: ['./coverage-modal.scss'],
})
export class CoverageModal {
    public coverageInput: CoverageInput;
    public selectedTabIndex: number = 0;

    constructor(private activeModal: NewModalRef<CoverageModal>) {}

    public dismiss(): void {
        this.activeModal.close();
    }
}
